module.exports = __webpack_public_path__ + "check.97861722cf175bd16686.svg";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/check.svg
// module id = ../../../../../src/assets/images/check.svg
// module chunks = styles